<template>
  <v-flex>
    <v-title>Call Management Console</v-title>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex xs12 sm12 md4 lg6>
            <v-radio-group v-model="rows[0].product" column class="ptop-0">
              <v-radio
                name="insight"
                value="insight"
                label="Vonex Insight"
              ></v-radio>
              <v-radio
                name="report"
                value="report"
                label="Vonex Report"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
          <div
            v-for="(prod, idx) in products.filter((x) => x == product)"
            :key="idx"
          >
            <v-title>Vonex {{ prod }}</v-title>
            <v-container>
              <v-alert v-if="rows[0].cmcID > 0" v-alert type="success"
              :value="true" saved o-k/<>
              <v-layout
                v-for="(field, index) in licences"
                :key="index"
                class="mt-3"
                row
              >
                <v-flex xs3 class="mt-2">
                  <v-subheader>
                    {{ field.label }}
                    <br />
                  </v-subheader>
                </v-flex>
                <v-flex xs2>
                  <vonex-text
                    :ref="field.name"
                    v-model.number="licences[index].quantity"
                    type="number"
                    :name="field.name"
                    :options="fieldConditions"
                    label="No. Licences"
                    :rule="`${
                      lineTotal(field) != 0 ? 'required' : true
                    } |integer|min_value:0`"
                    :hint="field.hint"
                    :suffix="lineTotal(field)"
                    persistent-hint
                    min="0"
                    hide-details
                    @keyup="checkCount(index)"
                  ></vonex-text>
                  <!-- <v-text-field
                    type="number"
                    v-model.number="licences[index].quantity"
                    :name="field.name"
                    label="No. Licences"
                    :v-validate="`${
                      lineTotal(field) != 0 ? 'required' : true
                    } |integer|min_value:0`"
                    :hint="field.hint"
                    :suffix="lineTotal(field)"
                    :error-messages="errors.collect(field.name)"
                    persistent-hint
                    min="0"
                    @keyup="checkCount(index)"
                  ></v-text-field> -->
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-subheader v-if="rows[0].product == 'insight'">
                    Note: Insight End Point Licence will be automatically
                    charged at $1 per month for all end points on your PBX.
                  </v-subheader>
                  <v-subheader v-else>
                    Note: Report End Point Licence will be automatically charged
                    at $2 per month for all end points on your PBX.
                  </v-subheader>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </ValidationObserver>

        <v-flex xs12>
          <v-btn color="primary" name="sbmt" @click="save">Save CMC</v-btn>

          <v-btn
            v-if="rows[0].cmcID > 0"
            color="primary"
            @click="deleteFromOrder()"
          >
            Delete from {{ isQuote ? 'Quote' : 'Order' }}
          </v-btn>
          <message-alert :component="message"></message-alert>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { HTTP } from '../http-common';
import { mapMultiRowFields } from 'vuex-map-fields';
import { mapActions, mapGetters, createNamespacedHelpers } from 'vuex';
const { mapActions: mapCmcActions, mapMutations: mapCmcMutations } =
  createNamespacedHelpers(`orders/Cmc`);
import { mapCmcFields, mapCmcMultiRowFields } from '../store/modules/orders';
import cmc from '@/models/cmcFields';
import { httpError } from '@/models/httpError';
import Utils from '@/mixins/utils.mixin';

export default {
  name: 'CreateCmc',
  mixins: [Utils],
  data() {
    return {
      product: 'insight',
      products: ['insight', 'report'],
      licences: [],
    };
  },
  computed: {
    ...mapGetters('orders', ['isQuote']),
    ...mapCmcFields(['message']),
    ...mapCmcMultiRowFields(['rows']),
  },
  async mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.licences = vm.rows[0].licenses.filter(
        (x) => x.product == vm.rows[0].product
      );
      vm.setMessage(new httpError());
      vm.getCmc()
        .then(() => {})
        .catch((err) => {});
    });
  },
  methods: {
    ...mapCmcActions([
      'setMessage',
      'getCmc',
      'saveCmc',
      'removeRow',
      'setDefault',
    ]),
    ...mapCmcMutations(['addRow']),
    save() {
      let vm = this;

      vm.licences.forEach((x) => {
        vm.rows[0].licenses.forEach((y) => {
          if (x.name === y.name && x.product === y.product)
            y.quantity = x.quantity;
        });
      });

      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (result) {
            try {
              await vm.saveCmc();
            } catch (err) {
              vm.setMessage({
                message: 'Unable to save: ' + err.message,
                httpStatus: 500,
              });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({
            message: err,
            httpStatus: 500,
          });
        });
    },

    lineTotal: function (field) {
      if (field) return '$' + field.cost * field.quantity;
      else return 0;
    },
    licenseTotal: function () {
      return this.rows[0].licenses
        .filter((x) => x.product == this.rows[0].product)
        .filter((x) => x.quantity !== null)
        .map((x) => x.cost * x.quantity)
        .reduce((acc, cur) => acc + cur, 0);
    },
    deleteFromOrder() {
      let vm = this;

      this.$dialog
        .confirm(
          'You are about to delete CMC from this order, this cannot be undone, are you sure?'
        )
        .then(function () {
          vm.removeRow(0).then(() => {
            vm.$router.push('order-summary');
          });
        });
    },
    checkCount(index) {
      let vm = this;
      if (vm.licences[index].quantity < 0) vm.licences[index].quantity = 0;
      else vm.licences[index].quantity = vm.licences[index].quantity;
    },
  },
};
</script>
